export default "{\n    \"callback\": \"Llamada de seguimiento\"\n}\n"